import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 4rem 0;
  text-align: center;
  h1 {
    margin: 0;
    font-size: 1.8rem;
    color: #333335;
    text-transform: uppercase;
    font-style: normal;
    font-weight: bold;
    font-weight: 700;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    color: #333335;
  }
`;

export { Container };
